(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FAQ-Anchor-Tabs-V2"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabHeads = document.querySelectorAll('.itg_tab_head');
  const tabContents = document.querySelectorAll('.itg_tab_content');

  // Function to activate a tab by data-id
  function activateTab(tabId) {
    // Remove active class from all tab heads
    tabHeads.forEach(t => t.classList.remove('active_tabs'));
    // Remove active class from all tab contents
    tabContents.forEach(c => c.classList.remove('itg_active_content'));

    // Activate the selected tab head
    const targetTab = document.querySelector(`.itg_tab_head[data-id="${tabId}"]`);
    if (targetTab) {
      targetTab.classList.add('active_tabs');
    }

    // Activate all content blocks with the matching data-id
    const targetContents = document.querySelectorAll(`.itg_tab_content[data-id="${tabId}"]`);
    targetContents.forEach(content => {
      content.classList.add('itg_active_content');
    });
  }

  // Handle tab clicks
  tabHeads.forEach(tab => {
    tab.addEventListener('click', function() {
      const tabId = this.getAttribute('data-id');
      activateTab(tabId);
      // Update URL hash without scrolling
      history.pushState(null, null, `#${this.id}`);
    });
  });

  // Handle anchor links on page load
  const hash = window.location.hash.replace('#', '');
  if (hash) {
    // Find the tab with the matching ID
    const targetTab = document.querySelector(`.itg_tab_head[id="${hash}"]`);
    if (targetTab) {
      const tabId = targetTab.getAttribute('data-id');
      activateTab(tabId);
      // Scroll to the tab
      targetTab.scrollIntoView({ behavior: 'smooth' });
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["FAQ-Collapsible-Tabs"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabHeads = document.querySelectorAll('.itg_tab_head');
  const tabContents = document.querySelectorAll('.itg_tab_content');

  tabHeads.forEach(tab => {
    tab.addEventListener('click', function() {
      const tabId = this.getAttribute('data-id');

      // Remove active class from all tabs and contents
      tabHeads.forEach(t => t.classList.remove('active_tabs'));
      tabContents.forEach(c => c.classList.remove('itg_active_content'));

      // Add active class to clicked tab and corresponding content
      this.classList.add('active_tabs');
      document.querySelector(`.itg_tab_content[data-id="${tabId}"]`).classList.add('itg_active_content');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["FAQ-Link-Tabs"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabLinks = document.querySelectorAll('.itg_tab_list a');
  const tabContents = document.querySelectorAll('.itg_tab_content');

  tabLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent navigation
      const tabHead = this.querySelector('.itg_tab_head');
      const tabId = tabHead.getAttribute('data-id');

      // Remove active class from all tabs and contents
      document.querySelectorAll('.itg_tab_head').forEach(t => t.classList.remove('active_tabs'));
      tabContents.forEach(c => c.classList.remove('itg_active_content'));

      // Add active class to clicked tab and corresponding content
      tabHead.classList.add('active_tabs');
      document.querySelector(`.itg_tab_content[data-id="${tabId}"]`).classList.add('itg_active_content');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Flex-FAQs"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabHeads = document.querySelectorAll('.itg_tab_head');
  const tabContents = document.querySelectorAll('.itg_tab_content');

  function activateTab(tabId) {
    // Remove active class from all tabs and contents
    tabHeads.forEach(t => t.classList.remove('active_tabs'));
    tabContents.forEach(c => c.classList.remove('itg_active_content'));

    // Add active class to the selected tab and content
    const targetHead = document.querySelector(`.itg_tab_head[data-id="${tabId}"]`);
    const targetContent = document.querySelector(`.itg_tab_content[data-id="${tabId}"]`);
    if (targetHead && targetContent) {
      targetHead.classList.add('active_tabs');
      targetContent.classList.add('itg_active_content');
      // Scroll to the content section
      targetContent.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Handle tab clicks
  tabHeads.forEach(tab => {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      const tabId = this.getAttribute('data-id');
      activateTab(tabId);
      // Update URL hash without jumping
      history.pushState(null, null, `#${tabId === 'tab1' ? 'section-1100TL' : tabId === 'tab2' ? 'section-3100TL-3200TL' : tabId === 'tab3' ? 'section-4100TL-4200TL' : 'section-' + tabId}`);
    });
  });

  // Handle anchor links from URL on page load
  if (window.location.hash) {
    const hash = window.location.hash.substring(1);
    let tabId;
    if (hash === 'section-1100TL') tabId = 'tab1';
    else if (hash === 'section-3100TL-3200TL') tabId = 'tab2';
    else if (hash === 'section-4100TL-4200TL') tabId = 'tab3';
    else if (hash === 'section-heading4') tabId = 'tab4';
    else if (hash === 'section-heading5') tabId = 'tab5';
    else if (hash === 'section-heading6') tabId = 'tab6';
    else if (hash === 'section-heading7') tabId = 'tab7';

    if (tabId) {
      activateTab(tabId);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
